import React, { FC, useEffect, useMemo, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    Tabs,
    Tab,
    Box,
    TextField,
    Autocomplete,
    Snackbar,
    Alert,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow,
    InputAdornment,
    Tooltip,
    IconButton,
    Paper,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    useTheme,
    useMediaQuery,
    Card,
} from "@mui/material";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { Drawer, Divider, List, ListItem, ListItemText } from "@mui/material";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { useTicketStore } from "../../hooks/useTicketStore";
import { useUbigeoStore } from "../../hooks/useUbigeoStore";
import { Supplier } from "../../types/slices/supplierType";
import { useSupplierStore } from "../../hooks/useSupplierStore";
import { ApiStatus } from "../../types/api/status";
import { useSoftnetStore } from "../../hooks/useSoftnetStore";
import { TicketAPI } from "../../apis/TicketAPI";
import { useDriverStore } from "../../hooks/useDriverStore";
import { usePatentStore } from "../../hooks/usePatentStore";
import { driver } from "../../types/slices/driverType";
import { patent } from "../../types/slices/patentType";
import { DrawerDispatchGuides } from "./components/drawers/DrawerDispatchGuides";
import { DrawerInvoiceRoute } from "./components/drawers/DrawerInvoiceRoute";
import { Route, Ticket } from "../../types/slices/ticketType";
import SendIcon from '@mui/icons-material/Send';
import DescriptionIcon from '@mui/icons-material/Description';
import { moneyCL } from "../../toolbox/helpers/money-helpers";
import moment from "moment";
import { IssueDrawer } from "./components/drawers/IssueDrawer";
import { useAuthStore } from "../../hooks/useAuthStore";
import { bussinesArea } from "../../types/slices/bussinesAreaType";
import { useBatchStore } from "../../hooks/useBatchStore";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { InvoiceData } from "../../components/print/Printtype";
import InvoicesToPrint from "../../components/print/InvoicesToPrint";
import logoHidalgo from "../../assets/image/logo-hidalgo.png"
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm"
import { useNavigate } from "react-router-dom"
import { RoutesMap } from "../../types"
import SearchIcon from '@mui/icons-material/Search'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { useSearcherStore } from "../../hooks/useSearcherStore";
import { formatDate, formatDateTime } from "../../toolbox/helpers/formatDateHelper";

interface Product {
    name: string
    quantity: number
    price: number
}

interface OrderRow {
    id: number
    date: string
    type_document: string
    customer: string
    net_total: number
    total_discount: number
    IVA: number
    total: number
    district: string
    address: string
    status: "pedido" | "facturado" | "ruta"
    n_ruta?: number
    folio?: number
    products: Product[]
}

interface ProcessOrder {
    ticket: Ticket
    nInterno: string
    ordenCompra: string
    references: Reference[]
    bussines_area?: bussinesArea
    folio?: string
}

interface Reference {
    type: string
    date: string
    folio: string
    reason?: string
}

const tabs = [
    { value: "pedido", color: "purple", icon: <ReceiptLongIcon fontSize="small" />, label: "Pedidos" },
    { value: "facturado", color: "orange", icon: <RequestQuoteIcon fontSize="small" />, label: "Facturación" },
    { value: "ruta", color: "green", icon: <LocalShippingOutlinedIcon fontSize="small" />, label: "En Ruta" },
]

const localDate = moment().format("YYYY-MM-DDTHH:mm")

export const OrderList: FC = () => {
    const navigate = useNavigate()
    const { user } = useAuthStore()

    const { getTicket, tickets: pedidos, getRoutes, createRoute, setSelectedRoute, routeSelected,
        deleteTicket, status: statusTicket, setSelectedTicket: setSelectedTicketStore,
        getByNroTicket
    } = useTicketStore()
    const { getDistricts, districts } = useUbigeoStore()
    const { createSalesDocument } = useSoftnetStore()
    const { getDrivers, drivers, driverSelected, setSelectedDriver } = useDriverStore()
    const { getPatents, patents, patentSelected, setSelectedPatent } = usePatentStore()
    const { runBatch } = useBatchStore();
    const { setSelectedCustomer } = useSearcherStore()

    const printRef = useRef<HTMLDivElement>(null);

    const [option, setOption] = useState("pedido")
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0])
    const [selectedComunas, setSelectedComunas] = useState<any[]>([])
    const [selectedOrders, setSelectedOrders] = useState<number[]>([])
    const [processing, setProcessing] = useState<boolean>(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [facturedCount, setFacturedCount] = useState(0)
    const [progressAlertOpen, setProgressAlertOpen] = useState(false)

    const [selectedClient, setSelectedClient] = useState<Supplier | null>(null)
    const { status: statusSupplier, supppliers, getSuppliers } = useSupplierStore()
    const theme = useTheme()
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))

    const [dispatchGuides, setDispatchGuides] = useState<any[]>([])
    const [drawerOpenRuta, setDrawerOpenRuta] = useState(false)

    const [drawerOpen, setDrawerOpen] = useState(false)
    const [selectedOrder, setSelectedOrder] = useState<any>(null)

    const [rutas, setRutas] = useState<any>([])

    const [routeModalOpen, setRouteModalOpen] = useState(false)
    const [routeDetails, setRouteDetails] = useState({
        patente: "",
        obs: "",
        conductor: "",
        fecha: localDate,
        hora: "",
    })

    const [openEmitModal, setOpenEmitModal] = useState(false)
    const [openDrawerInvoice, setOpenDrawerInvoice] = useState(false)
    const [emitOrderId, setEmitOrderId] = useState<number | null>(null)
    const [nInterno, setNInterno] = useState<string>("")
    const [ordenCompra, setOrdenCompra] = useState<string>("")
    const [isBulkEmit, setIsBulkEmit] = useState(false)


    const [allSelected, setAllSelected] = useState<boolean>(false)
    const [selectedTicket, setSelectedTicket] = useState<Ticket | null>(null)
    const [readOnly, setReadOnly] = useState<boolean>(false)
    const [rowSelected, setRowSelected] = useState<Ticket | undefined>(undefined)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [barcode, setBarcode] = useState<string>('')
    const [loadingRute, setLoadingRuta] = useState<boolean>(false)
    const [loadingTicket, setLoadingTicket] = useState<boolean>(false)
    const [routeType, setRouteType] = useState<'nueva' | 'existente'>('nueva')

    const selectAllRows = () => {
        if (allSelected) {
            setSelectedOrders([])
            setAllSelected(false)
        } else {
            const allIds = pedidos.map((pedido) => pedido.id)
            setSelectedOrders(allIds)
            setAllSelected(true)
        }
    }

    const isSelected = (row: any) => selectedOrders.some(selectedRow => selectedRow === row.id)

    useEffect(() => {
        getDataInitial()
        getDistrictsAPI()
    }, [])

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                const input = document.getElementById("input-search") as HTMLInputElement
                input?.focus()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [])
    useEffect(() => {
        if (barcode === "") {
            getPedidosAPI()
        } else {
            getTicketByNTicket(barcode)
        }
    }, [barcode, option, selectedDate, selectedComunas, selectedClient])

    useEffect(() => {
        if (routeModalOpen) {
            getRoutesAPI({ status_closure: 1 })
        }
    }, [routeModalOpen])

    const getPedidosAPI = async () => {
        setLoadingTicket(true)
        const filters: any = {}

        if (selectedDate) filters.date_until = selectedDate
        if (selectedComunas.length > 0) filters.district_ids = selectedComunas.map((c) => c.id)
        if (selectedClient) filters.idcustomer = selectedClient.id

        if (option === "pedido") {
            filters.status = 1
            filters.status_invoice = 0
            filters.types_document = [1, 2, 7]
        } else if (option === "facturado") {
            filters.status = 1
            filters.status_invoice = 1
            filters.types_document = [1, 2, 7]
        }

        if (option === "pedido" || option === "facturado") {
            await getTicket({
                ...filters,
                iduser_created: user?.iduser_type === 3 ? user?.id : undefined
            })
        }

        if (option === "ruta") {
            await getRoutesAPI(filters)
        }

        setSelectedOrders([])
        setAllSelected(false)
        setLoadingTicket(false)
    }

    const getRoutesAPI = async (params?: any): Promise<void> => {
        setLoadingRuta(true)
        const response = await getRoutes(params)
        setRutas(response || [])
        setLoadingRuta(false)
    }

    const handleOpenDrawer = (route: any) => {
        setSelectedRoute(route)
        setDispatchGuides(route.dispatch_guides.map((guide: any) => ({
            ...guide,
            details: guide.details.map((detail: any) => ({
                ...detail,
                productName: detail.ticket?.product?.name || "N/A",
            })),
        })))
        setDrawerOpenRuta(true)
    }


    const handleCloseDrawer = () => {
        setDrawerOpenRuta(false)
        setSelectedRoute({} as Route)
        setDispatchGuides([])
    }

    const getDataInitial = async () => {
        await getSuppliers()
        await getDrivers()
        await getPatents()
    }

    const getDistrictsAPI = async () => {
        await getDistricts()
    }

    const openRouteModal = () => setRouteModalOpen(true)

    const closeRouteModal = () => setRouteModalOpen(false)

    const handleRouteDetailsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setRouteDetails((prev) => ({ ...prev, [name]: value }))
    }

    const handleRowDetails = (row) => {
        setReadOnly(true)
        setSelectedTicket(row)
        setSelectedOrder(row)
        handleSelectOrder(row)
        setOpenEmitModal(true)
        // setDrawerOpen(true)
    }

    const closeDrawer = () => {
        setDrawerOpen(false)
        setSelectedOrder(null)
        setSelectedOrders([])
    }


    const handleChangeTab = async (_, newValue) => {
        setBarcode("")
        setOption(newValue)
        // if (newValue === "pedido") {
        //     await getTicket({ status: 1, status_invoice: 0, types_document: [1, 2, 7] })
        // } else if (newValue === "facturado") {
        //     await getTicket({ status: 1, status_invoice: 1, order_invoice: true, types_document: [1, 2, 7] })
        // }

        // if (newValue === "ruta") {
        //     await getRoutes({})
        // }
    }

    const handleFacturar = async (row) => {
        setSelectedTicket(row)
        handleSelectOrder(row)
        setReadOnly(false)
        setEmitOrderId(row.id)
        setIsBulkEmit(false)
        setOpenEmitModal(true)
    }

    const handleGlobalFacturar = async () => {
        if (selectedOrders.length === 0) return
        setIsBulkEmit(true)
        setOpenEmitModal(true)
    }

    const confirmEmitOrders = async (orders: ProcessOrder[]) => {
        setProcessing(true);
        await runBatch(orders, {
            title: "Emitiendo documentos",
            openPdf: "immediate",
            create: (o) =>
                createSalesDocument(o.ticket.id, {
                    nInterno: o.nInterno,
                    ordenCompra: o.ordenCompra,
                    references: o.references,
                    bussines_area: o?.bussines_area?.iderp,
                }),
            onFinally: () => {
                setProcessing(false);
                setOpenEmitModal(false);
                setSelectedOrders([]);
                getPedidosAPI();
            },
        });
    };

    const nameDoc = (idtype_document) => {
        switch (idtype_document) {
            case 7:
                return "GUIA DE DESPACHO"
            case 2:
                return "FACTURA ELECTRONICA";
            case 1:
                return "BOLETA ELECTRONICA";
            default:
                return "BOLETA ELECTRONICA"; 
        }
    }

    const mapTicketToInvoice = (t: Ticket): InvoiceData => ({
        idDocType: t.idtype_document,
        docType: nameDoc(t.idtype_document),
        folio: String(t.folio ?? ""),
        siiOffice: "S.I.I. SANTIAGO ORIENTE",
        issuedAt: "SANTIAGO " + t?.date_format,

        company: {
            name: t.company,
            rut: t.rut_company,
            giro: t.giro_company,
            addressLines: [t.address_company].filter(Boolean),
            logoUrl: logoHidalgo,
            website: "",
            phones: t.phone_company,
        },

        client: {
            rut: t.rut_customer,
            name: t.name_customer,
            giro: t.giro_customer ?? "",
            address: t.client_address ?? "",
            comuna: t.district_customer ?? "",
            ciudad: t.province_customer ?? "",
        },

        commercial: {
            paymentCondition: t.way_to_pay ?? "",
            sellerRut: "",
            internalNumber: t.n_internal ?? "",
            purchaseOrder: t.purchase_order ?? "",
            due: "",
            salesNote: "",
            quotation: "",
        },

        references: ([]).map((r: any) => ({
            type: r.type, folio: r.folio, date: r.date, reason: r.reason,
        })),

        items: (t.details ?? []).map((d: any, i: number) => ({
            item: i + 1,
            code: d.code_system ?? d.code_erp ?? "",
            description: d.product ?? d.name ?? "",
            quantity: Number(d.amount || 0),
            unit: d.unitmeasure_abr ?? "",
            unitPrice: Number(d.price || 0),
            discount: Math.max(0, (d.price * d.amount) - (d.net_subtotal ?? d.gross_subtotal ?? 0)),
            total: Number(d.net_subtotal ?? d.gross_subtotal ?? d.price * d.amount),
        })),

        totals: {
            exempt: Number(t.mnt_excent ?? 0),
            discount: Number(t.total_discount ?? 0),
            net: Number(t.net_total ?? 0),
            tax: Number(t.IVA ?? 0),
            total: Number(t.gross_total ?? t.total ?? 0),
        },
        headerBarcodeSrc: process.env.REACT_APP_ROOT_URL + '' + t?.barcode_path,
        barcodeSrc: t?.url_timbre,
        observation: ""
    });

    const isTicket = (t: Ticket | undefined): t is Ticket => t !== undefined;

    const invoicesToPrint: InvoiceData[] = useMemo(
        () => selectedOrders
            .map(id => pedidos.find(p => p.id === id))
            .filter(isTicket)
            .map(mapTicketToInvoice),
        [selectedOrders, pedidos]
    );

    const handlePrintSelected = useReactToPrint({
        contentRef: printRef,
        documentTitle: `documentos-${Date.now()}`
    });

    const clearDataRuta = async () => {
        setSelectedDriver({} as driver)
        setSelectedPatent({} as patent)
        setRouteDetails({
            patente: "",
            obs: "",
            conductor: "",
            fecha: localDate,
            hora: "",
        })
    }

    const handleGlobalRutear = async () => {

        if (routeType === "nueva") {
            const isEmptyObject = (obj: any) => {
                return obj && Object.keys(obj).length === 0 && obj.constructor === Object
            }

            if (!patentSelected || isEmptyObject(patentSelected) ||
                !driverSelected || isEmptyObject(driverSelected) ||
                !routeDetails.fecha) {
                alert("Todos los campos de la ruta son obligatorios.")
                return
            }
        }

        if (routeType === "existente") {
            if (!routeSelected) {
                return CustomSnackbar("warning", "Seleccione una ruta")
            }
        }

        const facturadosIds = selectedOrders.filter((id) => {
            const order = pedidos.find((item) => item.id === id)
            return order && order.status_invoice === "1"
        })

        if (facturadosIds.length === 0) {
            alert("No hay tickets facturados seleccionados para rutear.")
            return
        }

        const formattedDate = moment(routeDetails.fecha).format("YYYY-MM-DD HH:mm:ss")


        let payload: any = {
            idsticket: facturadosIds,
        }

        if (routeType === "nueva") {
            payload = {
                ...payload,
                date: formattedDate,
                patente: patentSelected.name,
                driver: driverSelected.name,
                observations: routeDetails.obs,
            }
        }

        if (routeType === "existente") {
            payload = {
                ...payload,
                idroute: routeSelected?.id
            }
        }

        await createRoute(payload)

        await getPedidosAPI()
        clearDataRuta()
    }


    const handleSelectOrder = (row) => {
        setSelectedOrders((prev) =>
            prev.includes(row.id) ? prev.filter((orderId) => orderId !== row.id) : [...prev, row.id]
        )
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Tab") {
                event.preventDefault()

                setOption((prevOption) => {
                    const currentIndex = tabs.findIndex((tab) => tab.value === prevOption)
                    const nextIndex = (currentIndex + 1) % tabs.length
                    return tabs[nextIndex].value
                })
            }
        }

        window.addEventListener("keydown", handleKeyDown)

        return () => {
            window.removeEventListener("keydown", handleKeyDown)
        }
    }, [])


    const handleWarehouseAction = async (warehouseId: number) => {
        try {
            const routeId = routeSelected.id
            const response = await TicketAPI.getDispatchPDF(routeId, warehouseId)
            const pdfURL = response?.url
            window.open(pdfURL, '_blank')
        } catch (error) {
            console.error('Error al obtener el PDF:', error)
            alert('Ocurrió un error al intentar descargar el PDF. Por favor, intenta nuevamente.')
        }

    }

    const openInvoiceModal = (item) => {
        setSelectedRoute(item)
        setOpenDrawerInvoice(true)
    }

    const closeInvoiceModal = () => setOpenDrawerInvoice(false)

    const onDeleteTicket = (rowSelected: Ticket): void => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async (): Promise<void> => {
        if (!rowSelected) return

        const resp = await deleteTicket(rowSelected?.id)
        if (resp === true) {
            setRowSelected(undefined)
            setShowModalConfirm(false)
            getPedidosAPI()
        }
    }

    const onEdit = (rowSelected: Ticket): void => {
        const customer = supppliers?.find(row => row.id === rowSelected?.idcustomer)
        if (customer?.id) setSelectedCustomer(customer)
        setSelectedTicketStore(rowSelected)
        navigate(RoutesMap.SEARCHER_COMPANY)
    }

    const getTicketByNTicket = async (nro_ticket: string | number): Promise<void> => {
        const resp = await getByNroTicket(
            nro_ticket
        )

        if (resp.length === 1) {
            handleRowDetails(resp[0])
        }
    }

    const getRouteByNTicket = async (nro_ticket: string | number): Promise<void> => {
        setLoadingRuta(true)
        const resp = await getByNroTicket(nro_ticket)
        setRutas(resp || [])
        setLoadingRuta(false)
        if (resp.length === 1) {
            setSelectedRoute(resp[0])
            setOpenDrawerInvoice(true)
        }
    }

    const openInvoice = (item: Ticket) => {
        window.open(item?.url_invoice, '_blank')
    }

    const openInvoiceAssignable = (item: Ticket) => {
        window.open(item?.url_invoice_assignable, '_blank')
    }

    const openInvoiceBoth = (item: Ticket) => {
        window.open(item?.url_invoice_both, '_blank')
    }

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
                <Typography sx={{ fontSize: "30px", fontWeight: "600", color: "#333" }}>
                    Gestión de pedidos
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} sx={{ textAlign: "right" }}>
                <Tabs
                    value={option}
                    onChange={handleChangeTab}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        "& .MuiTabs-indicator": { display: "none" },
                        "& .MuiTab-root": {
                            textTransform: "none",
                            minWidth: "auto",
                            padding: 0,
                            margin: "0 8px",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        },
                    }}
                >
                    {tabs.map(({ value, color, icon, label }) => (
                        <Tab
                            key={value}
                            value={value}
                            icon={React.cloneElement(icon, { style: { fontSize: "28px", color } })}
                            label={
                                <Box
                                    textAlign="center"
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    gap={0.5}
                                >
                                    {/* <Typography fontWeight="700" fontSize="16px">
                                        {value === 'pedido' && pedidos.length}
                                    </Typography> */}
                                    <Typography fontSize="14px" color="#666">
                                        {label}
                                    </Typography>
                                </Box>
                            }
                            sx={{
                                borderTop: `4px solid ${color}`,
                                width: 100,
                                padding: "8px 0",
                                borderRadius: "8px 8px 0 0",
                                transition: "all 0.3s",
                                "&:hover": { backgroundColor: "#f5f5f5" },
                                "&.Mui-selected": { backgroundColor: "#f0f0f0", color },
                            }}
                        />
                    ))}
                </Tabs>
            </Grid>

            <Grid container spacing={2} alignItems="flex-end" m={3} >
                {/* Título de los filtros */}
                <Grid item xs={12}>
                    <Typography sx={{ fontSize: "18px", fontWeight: "500", color: "#333", mb: 2 }}>
                        Filtros de búsqueda
                    </Typography>
                </Grid>

                {/* Filtro: Fecha */}
                <Grid item xs={12} sm={4}>
                    <TextField
                        label="Seleccionar fecha"
                        type="date"
                        size="small"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: 1,
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': { borderColor: '#E0E0E0' },
                                '&:hover fieldset': { borderColor: '#516E80' },
                                '&.Mui-focused fieldset': { borderColor: '#516E80' },
                            },
                        }}
                    />
                </Grid>

                {/* Filtro: Comuna */}
                <Grid item xs={12} sm={4}>
                    <Autocomplete
                        multiple
                        options={districts || []}
                        value={selectedComunas || []}
                        onChange={(e, newValue) => setSelectedComunas(newValue)}
                        getOptionLabel={(option) => option.name || ''}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Buscar comuna"
                                placeholder="Seleccione comunas"
                                size="small"
                                fullWidth
                                sx={{
                                    backgroundColor: '#fff',
                                    borderRadius: 1,
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': { borderColor: '#E0E0E0' },
                                        '&:hover fieldset': { borderColor: '#516E80' },
                                        '&.Mui-focused fieldset': { borderColor: '#516E80' },
                                    },
                                }}
                            />
                        )}
                        sx={{ width: '100%' }}
                        limitTags={3}
                    />
                </Grid>

                {/* Filtro: Cliente */}
                {
                    (option === "pedido" || option === "facturado") &&
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            value={selectedClient}
                            options={supppliers || []}
                            onChange={(e, value) => setSelectedClient(value)}
                            getOptionLabel={(option) => option.name_rz + ' - ' + option.rut}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Buscar cliente"
                                    placeholder="Seleccione cliente"
                                    size="small"
                                    fullWidth
                                    sx={{
                                        backgroundColor: '#fff',
                                        borderRadius: 1,
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': { borderColor: '#E0E0E0' },
                                            '&:hover fieldset': { borderColor: '#516E80' },
                                            '&.Mui-focused fieldset': { borderColor: '#516E80' },
                                        },
                                    }}
                                />
                            )}
                        />
                    </Grid>
                }

                <Grid item xs={4}>
                    <TextField
                        id="input-search"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon fontSize="small" />
                                </InputAdornment>
                            )
                        }}
                        value={barcode}
                        onChange={(e) => {
                            setBarcode(e.target.value)
                        }}
                        placeholder="Buscar..."
                        size="small"
                    />
                </Grid>

                {option === "pedido" && (
                    <Grid item xs={8} sx={{ textAlign: "right" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={selectedOrders.length === 0 || processing}
                            onClick={handleGlobalFacturar}
                        >
                            {processing ? "Procesando..." : "Emitir Seleccionados"}
                        </Button>
                    </Grid>
                )}

                {option === "facturado" && (
                    <Grid item xs={8} sx={{ textAlign: "right" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={selectedOrders.length === 0 || processing}
                            onClick={() => openRouteModal()}
                        >
                            {processing ? "Procesando..." : "Enrutar Seleccionados"}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            disabled={selectedOrders.length === 0}
                            onClick={handlePrintSelected}
                            style={{ marginLeft: 2 }}
                        >
                            Imprimir Seleccionados
                        </Button>
                        <div style={{ position: "absolute", left: -99999, top: 0 }}>
                            <InvoicesToPrint ref={printRef} invoices={invoicesToPrint} />
                        </div>
                        {/* <Button
                        variant="contained"
                        color="secondary"
                        sx={{marginLeft: 2}}
                        disabled={!canGroupOrders()}
                        onClick={handleGroupOrders}
                    >
                        Agrupar Seleccionados
                    </Button> */}
                    </Grid>
                )}
            </Grid>

            <Grid item xs={12}>
                {option === "pedido" && (
                    <CustomTable
                        columns={[
                            { type: "checkbox", field: "", label: "", align: "center" },
                            { type: 'options', field: 'options', label: '', align: 'center' },
                            {
                                type: "text", field: "date", label: "Fecha", align: "center",
                                format: (row) => formatDate(row.date)
                            },
                            { type: "text", field: "nro_ticket", label: "N ticket", align: "center" },
                            { type: "text", field: "type_document", label: "Tipo", align: "center" },
                            { type: "text", field: "rut_customer", label: "RUT", align: "center" },
                            { type: "text", field: "name_customer", label: "Cliente", align: "center" },
                            { type: "text", field: "district_customer", label: "Comuna", align: "center" },
                            { type: "text", field: "client_address", label: "Dirección", align: "center" },
                            { type: "text", field: "edit", label: "Modificado", align: "center", format: (row) => row.edit == '1' ? 'Si' : 'No' },
                            { type: "detail", field: "", label: "", align: "center" },
                        ]}
                        hasOptions
                        onEdit={onEdit}
                        onDelete={onDeleteTicket}
                        onHelper={handleFacturar}
                        tooltip_helper={"Emitir"}
                        icon_helper={<SendIcon fontSize="small" />}
                        rows={pedidos}
                        onRowClick={() => { }}
                        isSelected={isSelected}
                        selectAll={selectAllRows}
                        allSelected={allSelected}
                        onCheckbox={handleSelectOrder}
                        onDetails={handleRowDetails}
                        loading={statusTicket === ApiStatus.FETCHING}
                        withoutTitle
                    />
                )}

                {option === "facturado" && (
                    <CustomTable
                        columns={[
                            { type: "checkbox", field: "", label: "", align: "center" },
                            {
                                type: "text", field: "date_invoice", label: "Fecha", align: "center",
                                format: (row) => formatDateTime(row.date_invoice)
                            },
                            { type: "text", field: "nro_ticket", label: "N ticket", align: "center" },
                            { type: "text", field: "folio", label: "Folio", align: "center" },
                            { type: "text", field: "type_document", label: "Tipo", align: "center" },
                            { type: "text", field: "rut_customer", label: "RUT", align: "center" },
                            { type: "text", field: "name_customer", label: "Cliente", align: "center" },
                            { type: "text", field: "district_customer", label: "Comuna", align: "center" },
                            { type: "text", field: "client_address", label: "Dirección", align: "center" },
                            { type: "detail", field: "", label: "", align: "center" },
                        ]}
                        rows={pedidos}
                        onRowClick={() => { }}
                        isSelected={isSelected}
                        selectAll={selectAllRows}
                        allSelected={allSelected}
                        onCheckbox={handleSelectOrder}
                        onDetails={handleRowDetails}
                        onHelper={openInvoice}
                        icon_helper={<PictureAsPdfIcon/>}
                        tooltip_helper={"Ver documento"}
                        onHelper2={openInvoiceAssignable}
                        icon_helper2={<PictureAsPdfIcon/>}
                        tooltip_helper2={"Ver cedible"}
                        onHelper3={openInvoiceBoth}
                        icon_helper3={<PictureAsPdfIcon/>}
                        tooltip_helper3={"Ver ambos"}
                        loading={loadingTicket}
                        withoutTitle
                    />
                )}

                {option === "ruta" && (
                    <>
                        <CustomTable
                            columns={[
                                {
                                    type: "text", field: "date", label: "Fecha", align: "center",
                                    format: (row) => formatDateTime(row.date)
                                },
                                { type: "text", field: "n_route", label: "N Ruta", align: "center" },
                                { type: "text", field: "driver", label: "Conductor", align: "center" },
                                { type: "text", field: "patente", label: "Patente", align: "center" },
                                { type: "text", field: "status_closure_name", label: "Estado", align: "center" },
                                { type: "detail", field: "", label: "Detalles", align: "center" },
                            ]}
                            rows={rutas}
                            onRowClick={() => { }}
                            onDetails={handleOpenDrawer}
                            onHelper={openInvoiceModal}
                            tooltip_helper={"Ver facturas"}
                            icon_helper={<DescriptionIcon fontSize="small" />}
                            loading={loadingRute}
                            withoutTitle
                        />

                        {/* Drawer facturas asociadas en la ruta*/}

                        <DrawerInvoiceRoute
                            drawerOpen={openDrawerInvoice}
                            handleCloseDrawer={closeInvoiceModal}
                        />

                        {/* Drawer para las Dispatch Guides */}
                        <DrawerDispatchGuides
                            drawerOpenRuta={drawerOpenRuta}
                            handleCloseDrawer={handleCloseDrawer}
                            dispatchGuides={dispatchGuides}
                            handleWarehouseAction={handleWarehouseAction}
                        />
                    </>
                )}

            </Grid>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
            >
                <Alert onClose={() => setSnackbarOpen(false)} severity="success">
                    Facturado correctamente
                </Alert>
            </Snackbar>

            {progressAlertOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: 16,
                        right: 16,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        boxShadow: 4,
                        borderRadius: 2,
                        p: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        minWidth: "300px",
                    }}
                >
                    <Typography variant="body2">
                        {option === "pedido" && `Facturado ${facturedCount} de ${selectedOrders.length}`}
                        {option === "facturado" && `Enruteado ${facturedCount} de ${selectedOrders.length}`}
                    </Typography>

                </Box>
            )}

            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={closeDrawer}
                PaperProps={{
                    sx: {
                        width: 550,
                        backgroundColor: "#f9f9f9",
                        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
                    },
                }}
            >
                <Box sx={{ p: 3 }}>
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontWeight: "bold", color: "#333" }}
                    >
                        Detalles del Pedido
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    {selectedOrder && (
                        <Box>
                            <Typography variant="body1" sx={{ mb: 1, display: 'block' }}>
                                <strong>Cliente:</strong> {selectedOrder.name_customer}
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 1, display: 'block' }}>
                                <strong>Dirección:</strong> {selectedOrder.client_address}
                            </Typography>
                            <Typography variant="body1" sx={{ mb: 1, display: 'block' }}>
                                <strong>Fecha:</strong> {selectedOrder.date}
                            </Typography>

                            <Divider sx={{ my: 2 }} />


                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell><strong>Producto</strong></TableCell>
                                            <TableCell align="center"><strong>Cant.</strong></TableCell>
                                            <TableCell align="center"><strong>Precio</strong></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(selectedOrder?.details || []).map((product, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{product.product}</TableCell>
                                                <TableCell align="center">
                                                    {product.amount}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {moneyCL(product.price)}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Divider sx={{ my: 2 }} />

                            {/* Total del pedido */}
                            <Typography
                                variant="h6"
                                sx={{
                                    textAlign: "right",
                                    fontWeight: "bold",
                                    color: "#444",
                                }}
                            >
                                Total: {moneyCL(selectedOrder.total)}
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Drawer>


            <Dialog
                open={routeModalOpen}
                onClose={closeRouteModal}
                sx={{
                    '& .MuiDialog-paper': {
                        minWidth: isSmallScreen ? '90%' : 600,
                        borderRadius: 3,
                        padding: 1
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 'bold',
                        fontSize: 20,
                        pb: 1,
                        textAlign: 'center',
                    }}
                >
                    Detalles de la Ruta
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2}>

                        <Grid item xs={12}>
                            <FormControl component="fieldset" sx={{ width: '100%' }}>
                                <FormLabel
                                    sx={{ fontWeight: 'bold', color: 'text.primary', mb: 1 }}
                                >
                                    Tipo de Ruta
                                </FormLabel>
                                <RadioGroup
                                    row
                                    value={routeType}
                                    onChange={(e) =>
                                        setRouteType(e.target.value as 'nueva' | 'existente')
                                    }
                                >
                                    <FormControlLabel value="nueva" control={<Radio />} label="Nueva" />
                                    <FormControlLabel
                                        value="existente"
                                        control={<Radio />}
                                        label="Existente"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>

                        {routeType === 'nueva' && (
                            <>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        value={driverSelected ?? null}
                                        options={drivers || []}
                                        onChange={(e, value) =>
                                            setSelectedDriver(value || ({} as driver))
                                        }
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Buscar conductor"
                                                placeholder="Seleccione conductor"
                                                size="small"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Autocomplete
                                        value={patentSelected ?? null}
                                        options={patents || []}
                                        onChange={(e, value) =>
                                            setSelectedPatent(value || ({} as patent))
                                        }
                                        getOptionLabel={(option) => option?.name ?? ''}
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Buscar patente"
                                                placeholder="Seleccione patente"
                                                size="small"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Observaciones"
                                        name="obs"
                                        value={routeDetails.obs}
                                        onChange={handleRouteDetailsChange}
                                        fullWidth
                                        margin="dense"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        label="Fecha y Hora"
                                        name="fecha"
                                        type="datetime-local"
                                        value={routeDetails.fecha || localDate}
                                        onChange={handleRouteDetailsChange}
                                        fullWidth
                                        margin="dense"
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                            </>
                        )}

                        {routeType === 'existente' && (
                            <>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        value={routeSelected ?? null}
                                        options={rutas || []}
                                        onChange={(e, value) => setSelectedRoute(value || ({} as Route))}
                                        getOptionLabel={(option) =>
                                            option?.driver && option?.date && option?.n_route
                                                ? `${option.driver} | ${formatDateTime(option?.date)} | #${option.n_route}`
                                                : ''
                                        }
                                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Conductor | Fecha | Ruta"
                                                placeholder="Seleccione conductor, fecha y ruta"
                                                size="small"
                                                fullWidth
                                            />
                                        )}
                                    />

                                </Grid>

                                {routeSelected && (
                                    <Grid item xs={12}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                p: 2,
                                                borderRadius: 2,
                                                backgroundColor: '#f9f9f9',
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                Información de la Ruta
                                            </Typography>
                                            <Divider sx={{ mb: 2 }} />

                                            <Grid container spacing={1}>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2">
                                                        <strong>Fecha:</strong> {formatDateTime(routeSelected.date)}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2">
                                                        <strong>Patente:</strong> {routeSelected.patente}
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant="body2">
                                                        <strong>Observaciones:</strong> {routeSelected.observations}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid>
                                )}
                            </>
                        )}
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => {
                        closeRouteModal()
                        clearDataRuta()
                    }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => {
                            closeRouteModal()
                            handleGlobalRutear()
                        }}
                        color="primary"
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            {
                selectedOrders.length > 0 && openEmitModal &&
                <IssueDrawer
                    openEmitModal={openEmitModal}
                    handleCloseDrawer={() => setOpenEmitModal(false)}
                    selectedTickets={selectedOrders.map(id => pedidos.find(pedido => pedido.id === id)).filter(Boolean) as Ticket[]}
                    confirmEmitOrders={confirmEmitOrders}
                    readOnly={readOnly}
                    setSelectedOrders={setSelectedOrders}
                    // confirmEmitOrder={confirmEmitOrder}
                    processing={processing}
                />
            }
            {showModalConfirm && (
                <ModalConfirm
                    open={showModalConfirm}
                    closeModal={() => { setShowModalConfirm(false) }}
                    onConfirm={onDeleteConfirm}
                    status={statusTicket === ApiStatus.FETCHING}
                />
            )}

        </Grid>
    )
}
